/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Loader} from 'react-overlay-loader';
import {Redirect} from 'react-router-dom';
import xosphereLogo from '../../assets/images/xosphere-logo.png';
import * as actions from '../../store/actions';
import Error from '../../components/UI/Error';
import queryString from "query-string";

// Allowlist of error codes from ?error= (sent by backend redirects). Maps to safe, app-defined messages.
// Never render raw query params. Backend sends codes from dashboard/samlAcs.go LoginErrorCode* constants.
const LOGIN_ERROR_CODES = {
    not_authorized: "You are not authorized to sign in. Please contact your administrator.",
    sso_failed: "An error occurred during sign-in. For assistance please contact support@xosphere.io.",
    generic: "An error occurred. Please try again or contact support@xosphere.io.",
};

function loginErrorMessageFromQueryCode(code) {
    if (code === null || code === undefined || code === "") return null;
    const s = typeof code === "string" ? code : String(code);
    return LOGIN_ERROR_CODES[s] || LOGIN_ERROR_CODES.generic;
}

class Login extends Component {
    state = {
        error: null,
        backToLogin: false,
        email: this.props.email ? this.props.email : "",
    };

    UNSAFE_componentWillMount() {
        const qs = queryString.parse(this.props.location.search);
        const message = loginErrorMessageFromQueryCode(qs.error);
        if (message) {
            this.setState({ error: message });
        }
        const backToLogin = qs.backToLogin;
        if (backToLogin) {
            this.setState({backToLogin: true})
        }
    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.setState({backToLogin: false})
        this.props.onTryLoginWithEmail(this.state.email)
    };

    handleEmailChange = (event) => {
        this.setState({email: event.target.value.trim()})
    };

    handleSignup = (event) => {
        window.location.href = 'https://portal.xosphere.io/signup'
    };

    handleLoginKeyPress = (event) => {
        if(event.key === 'Enter') {
            event.preventDefault();
            this.setState({backToLogin: false})
            this.props.onTryLoginWithEmail(this.state.email)
        }
    };

    render() {
        if (this.props.nextPage) {
            if (this.state.email && !this.state.backToLogin) {
                return <Redirect to={this.props.nextPage}/>
            }
        }

        return (
            <div className="container-fluid">
                <Loader fullPage={true} loading={this.props.loading}/>
                <div className="row justify-content-md-center">
                    <div className="col-lg-10 col-md-12 text-center">
                        <div className="row justify-content-sm-center login-top">
                            <div className="col-lg-4 col-md-5 col-sm-7 text-center"><img
                                src={xosphereLogo} alt="" title="" className="mb-4"/>
                                <Error errorMsg={this.props.error || this.state.error} divClass="col-lg-5 col-sm-6 col-center"/>
                                <div className="form-group row no-gutters">
                                    <div className="col-11">
                                        <input type="email" className="form-control" id="login" placeholder="Email Address" autoComplete="username" autoFocus
                                               value={this.state.email} onChange={e => this.handleEmailChange(e)} onKeyPress={e => this.handleLoginKeyPress(e)}/>
                                        <input type="password" hidden="{true}" className="form-control" id="password" autoComplete="current-password" />
                                    </div>
                                    <div className="col-1"></div>
                                </div>
                                <div className="form-group mb-5">
                                    <input type="submit" value="Log In" className="btn btn-primary"
                                           onClick={this.handleSubmit}></input>
                                </div>
                                <div className="form-group"> Don't have an account? <a href="#"
                                                                                       onClick={this.handleSignup}
                                                                                       className="btn-link">Signup</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        nextPage: state.login.nextPage,
        loading: state.login.loading,
        error: state.login.error,
        redirect: state.login.redirect,
        email: state.login.email,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        onTryLoginWithEmail: (email) => dispatch(actions.tryLoginWithEmail(email))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);